<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <reviews-summary-unified />
    </div>
  </div>
</template>

<script>
import ReviewsSummaryUnified from '@/views/_components/ReviewsSummaryUnified.vue';

/**
 * @module views/analytics/ReviewsAnalytics
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  name: 'ReviewsAnalytics',
  components: {
    ReviewsSummaryUnified,
  },
};
</script>

<style scoped>

</style>
